import * as types from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  items: {},
};

export default function promotorsGetCurrentReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_CURRENT_PROMOTOR_INIT:
      return { ...state, error: null, isLoading: false };

    case types.GET_CURRENT_PROMOTOR_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_CURRENT_PROMOTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
